import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Environment } from 'src/environment';

import { FarmSettings, UpsertFarmSettingsResponse } from '../models/farm-settings.model';

@Injectable({
  providedIn: 'root',
})
export class FarmSettingsService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  protected baseUrl = this.env.API_BASE_URL + '/service/flock-registration/secure';

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);
  constructor() {}

  getFarmSettings(): Observable<FarmSettings | HttpErrorResponse> {
    return this.http.get<FarmSettings>(`${this.baseUrl}/sustainability/farm-settings`).pipe(
      map((farmSettings) => farmSettings),
      catchError((error: HttpErrorResponse) => {
        if (error.status === 404) {
          return of({ enableCO2Calculation: false } as FarmSettings);
        } else {
          return throwError(() => new Error(error.message));
        }
      }),
    );
  }

  upsertFarmSettings(
    farmSettings: FarmSettings,
  ): Observable<UpsertFarmSettingsResponse | HttpErrorResponse> {
    return this.http
      .post<UpsertFarmSettingsResponse>(
        `${this.baseUrl}/sustainability/farm-settings`,
        farmSettings,
        {},
      )
      .pipe(catchError((error: HttpErrorResponse) => throwError(() => new Error(error.message))));
  }
}
